module.exports = __webpack_public_path__ + "562a7255ccf32e62cb27b2e7916fca8c.svg";